interface UtilPluralize {
  one: string; // Форма слова для единственного числа (например, "магазин" или "пара")
  few: string; // Форма слова для чисел 2-4 (например, "магазина" или "пары")
  many: string; // Форма слова для множественного числа (например, "магазинов" или "пар")
}

/**
 * Функция возвращает подходящее склонение слова в зависимости от числа.
 *
 * @param one форма слова для чисел, заканчивающихся на 1 (кроме 11), например, "магазин"
 * @param few форма слова для чисел, заканчивающихся на 2-4 (кроме 12-14), например, "магазина"
 * @param many форма слова для остальных чисел, например, "магазинов"
 *
 * @returns Функция, которая принимает число и возвращает слово в нужной форме
 *
 * @example
 * const pluralizeShopText = utilPluralize({
 *   one: 'магазин',
 *   few: 'магазина',
 *   many: 'магазинов',
 * });
 *
 * console.log(`Самовывоз из ${10} ${pluralizeShopText(10)}`); // "Самовывоз из 10 магазинов"
 */
export const utilPluralize = ({ one, few, many }: UtilPluralize) => {
  const pluralRules = new Intl.PluralRules('ru-RU');

  return (count: number | string): string => {
    const rule = pluralRules.select(+count);

    switch (rule) {
      case 'one':
        return one;
      case 'few':
        return few;
      default:
        return many;
    }
  };
};
